import { VehicleSurveyImage } from "../interfaces/altair";
import { apiFetch } from "../utils/api";

// ═══════════════════════════════════════════════════════════
// INTERFACES
// ═══════════════════════════════════════════════════════════

export interface AnalyzeVehicleImagesResponse {
  vehicleAnalyzeDescription: string;
}

// ═══════════════════════════════════════════════════════════
// API FUNCTIONS
// ═══════════════════════════════════════════════════════════

/**
 * Analyzes vehicle images using Gemini AI to generate damage description
 * Takes 4 vehicle images (Front, Right, Back, Left) and returns a formal Arabic description
 * @param images Array of vehicle survey images with base64 data
 * @returns Promise with vehicle analysis description
 */
export const analyzeVehicleImages = async (
  images: VehicleSurveyImage[]
): Promise<AnalyzeVehicleImagesResponse> => {
  const response = await apiFetch("/Gemini/Analyze-vehicle-Images", {
    method: "POST",
    body: JSON.stringify({
      Documents: images.map((img) => ({
        DocumentName: `${img.side}.jpeg`,
        // Ensure data has the data URL prefix
        Data: img.data.startsWith("data:")
          ? img.data
          : `data:image/jpeg;base64,${img.data}`,
      })),
    }),
  });

  if (!response.ok) {
    let errorMessage = `Backend error while analyzing vehicle images: ${response.status} ${response.statusText}`;
    try {
      const errorData = await response.json();
      errorMessage = errorData.message || errorMessage;
    } catch {
      // Use default error message if JSON parsing fails
    }
    throw new Error(errorMessage);
  }

  const data = await response.json();
  return {
    vehicleAnalyzeDescription:
      data.vehicleAnalyzeDescription ||
      data.VehicleAnalyzeDescription ||
      "السيارة بحالة جيده",
  };
};

